import React from 'react';
import moment from 'moment';
import { AuditLogRow } from '../../../types/AuditLogs';

interface AuditLogTableProps {
    rows: AuditLogRow[];
    loading: boolean;
    error?: string;
}

export const AuditLogTable = ({ rows, loading, error }: AuditLogTableProps) => {
    if (loading) {
        return (
            <div className="audit-log-status" role="status">
                Loading audit log entries...
            </div>
        );
    }

    if (error) {
        return (
            <div className="audit-log-status audit-log-status-error" role="alert">
                {error}
            </div>
        );
    }

    if (!rows.length) {
        return (
            <div className="audit-log-status audit-log-status-empty" role="status">
                No audit log entries match the current search and filters.
            </div>
        );
    }

    return (
        <div className="audit-log-table-wrapper">
            <table className="audit-log-table">
                <thead>
                    <tr>
                        <th>Timestamp (UTC)</th>
                        <th>Actor (User Email)</th>
                        <th>Target (Client / Property)</th>
                        <th>Action Category</th>
                        <th>Action / Change Detail</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map(row => (
                        <tr key={row.id}>
                            <td>{moment.utc(row.timestamp).format('YYYY-MM-DD HH:mm:ss [UTC]')}</td>
                            <td>{row.actor || '—'}</td>
                            <td>{row.target || '—'}</td>
                            <td>{row.actionCategory || '—'}</td>
                            <td>
                                <div className="audit-log-action-detail-cell">
                                    <div className="audit-log-action-text">{row.actionDetail || '—'}</div>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
